class ExternalLink {
  constructor() {
    this.input = jQuery(`<div class="link-dialog-form-group">
    <label class="link-dialog-label" for="link-external-url">Link to an external URL</label>
    <input type="text" id="link-external-url" name="external-url" placeholder="http://example.com" />
  </div>`);
  }

  get value() {
    var url = this.input.find("#link-external-url").val();
    if (url && url !== "" && !url.match(/^(\?|mailto:|tel:|https?:\/\/)/)) {
      url = "http://" + url;
    }
    return url;
  }

  set value(val) {
    this.input.find("#link-external-url").val(val);
  }

  get defaultTitle() {
    return this.value;
  }
}

window.ExternalLink = ExternalLink;
